<script setup lang="ts" generic="T">
import DropdownSelect from '@/core/elements/DropdownSelect.vue';
import { ISelectOption } from '@/interfaces';
import { useField } from 'vee-validate';
import { computed, watch } from 'vue';

const emit = defineEmits<{
  'update:value': [value: T];
}>();

const props = withDefaults(
  defineProps<{
    label?: string;
    name: string;
    options: ISelectOption<T>[];
    value?: T;
    disabled?: boolean;
  }>(),
  {
    label: undefined,
    value: undefined,
    disabled: false,
  },
);

const { handleChange, value } = useField(() => props.name, undefined, {
  initialValue: props.value ?? '',
});
const valueTransformed = computed(() => value as T);

const handleInput = (val: T): void => {
  handleChange(val, true);
  emit('update:value', val);
};

watch(
  () => props.value,
  () => {
    handleChange(props.value, true);
  },
  { immediate: true },
);
</script>

<template>
  <DropdownSelect
    :label="label"
    theme="input"
    :model-value="valueTransformed"
    :name="name"
    :options="options"
    :disabled="disabled"
    @update:model-value="handleInput($event as T)"
  />
</template>
